/* Public landing — anonymous visitor sees this first. The CTA leads into
   the pathway selector (Phase 2), which leads into the read-only preview.
   Phase 3 adds the "Sign in to save" path on top of this same surface. */

import { Link } from 'react-router-dom';

export function HomePage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
      <div className="eyebrow mb-5">Solutions · Workspace</div>
      <h1 className="editorial-h1 mb-5">
        CYBHI Participation, <em className="italic text-accent">structured.</em>
      </h1>
      <p className="editorial-deck mb-10 max-w-2xl">
        A scenario-aware workspace for California LEAs working through
        participation in the Children &amp; Youth Behavioral Health Initiative —
        pathway selection, agreement tracking, vendor evaluation, and team
        coordination, all in one place.
      </p>

      <div className="flex flex-wrap gap-7 items-center mb-14">
        <Link to="/select" className="btn-text">
          Start with the pathway selector
        </Link>
        <span className="font-editorial italic text-[15px] text-ink-muted">
          ~2 minutes · no sign-in required to preview
        </span>
      </div>

      {/* Card row — what this app will offer when complete. Lifted directly
          from the document's own framing (Independent / Lead / Member). */}
      <div className="grid md:grid-cols-3 gap-px bg-rule border border-rule mb-12">
        <div className="bg-paper p-7">
          <div className="font-editorial italic text-xs text-accent mb-2">01 · Pathway</div>
          <div className="font-editorial text-[19px] font-medium text-ink mb-2">
            Independent or Consortium?
          </div>
          <div className="font-editorial text-[15px] text-ink-soft leading-relaxed">
            Three top-level pathways, six sub-scenarios. We filter the
            checklist to only what applies to you.
          </div>
        </div>
        <div className="bg-paper p-7">
          <div className="font-editorial italic text-xs text-accent mb-2">02 · Coordinate</div>
          <div className="font-editorial text-[19px] font-medium text-ink mb-2">
            One workspace per LEA.
          </div>
          <div className="font-editorial text-[15px] text-ink-soft leading-relaxed">
            Invite your billing lead, pupil services lead, IT, legal counsel.
            Everyone sees the same checklist, in the same state.
          </div>
        </div>
        <div className="bg-paper p-7">
          <div className="font-editorial italic text-xs text-accent mb-2">03 · Export</div>
          <div className="font-editorial text-[19px] font-medium text-ink mb-2">
            Print to PDF or Excel.
          </div>
          <div className="font-editorial text-[15px] text-ink-soft leading-relaxed">
            Generate a personalized, board-ready project plan from your
            workspace, anytime.
          </div>
        </div>
      </div>

      <p className="font-editorial italic text-sm text-ink-muted max-w-2xl leading-relaxed">
        Source material: DHCS CYBHI Fee Schedule Program Manual (August 2025),
        CYBHI Participation Models (December 2025), and Carelon Behavioral
        Health onboarding resources. This site is an unaffiliated practitioner
        tool; nothing here constitutes legal advice.
      </p>
    </div>
  );
}
